import {
  numericKeyDownHandler,
  positiveIntegerInputHandler,
} from 'module/helpers/input-number-event-handlers';
import {
  EstimateFieldFilter,
  EstimateFieldFilterOperationType,
  EstimateRelativeDirection,
} from 'module/types/filter-field/filter/estimate';
import { Menu } from 'module/ui/components/atoms/dropdown';
import { InputNumber } from 'module/ui/components/atoms/input/input-number';
import { Radio } from 'module/ui/components/atoms/radio';
import { Select } from 'antd';
import { snakeCase } from 'lodash';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Line, Lines } from './components';

const RelativeDirectionSelect = styled(Select)`
  min-width: 96px;
  max-width: 96px;
  margin-left: var(--spacing-03);

  .ant-select-selection-item {
    padding-left: var(--spacing-03);
  }

  .ant-select-arrow {
    right: var(--spacing-03);
  }
`;

const DaysInput = styled(InputNumber)`
  padding-left: var(--spacing-02);
  min-width: 64px;
  max-width: 64px;
  margin-right: var(--spacing-03);

  input {
    text-align: right;
    padding-right: var(--spacing-04);
  }
`;

export const renderRelativeMenuItem = (
  filter: EstimateFieldFilter,
  type: EstimateFieldFilterOperationType,
  onChange: (filter: EstimateFieldFilter) => void,
) => (
  <Menu.Item key={type.toString()} className="date-criteria">
    <Lines>
      <Line>
        <Radio checked={filter.type === type} />{' '}
        <FormattedMessage
          id={`task_list.filters.${snakeCase(
            EstimateFieldFilterOperationType[type],
          )}`}
        />
      </Line>
      {filter.type === type && (
        <Line>
          <DaysInput
            className="date-criteria"
            autoFocus
            min={0}
            max={1095}
            value={(filter as EstimateFieldFilter).days}
            onKeyDown={numericKeyDownHandler()}
            onInput={() => positiveIntegerInputHandler(0, 1095)}
            onChange={(value) =>
              onChange({
                ...filter,
                days:
                  value == null || value.toString().trim().length === 0
                    ? undefined
                    : parseInt(value.toString(), 10),
              } as EstimateFieldFilter)
            }
          />
          <FormattedMessage id="task_list.filters.days" />
          <RelativeDirectionSelect
            className="date-criteria"
            value={(filter as EstimateFieldFilter).direction}
            onChange={(value) =>
              onChange({ ...filter, direction: value } as EstimateFieldFilter)
            }
          >
            <RelativeDirectionSelect.Option
              value={EstimateRelativeDirection.Early}
            >
              <FormattedMessage id="task_list.filters.early" />
            </RelativeDirectionSelect.Option>
            <RelativeDirectionSelect.Option
              value={EstimateRelativeDirection.Late}
            >
              <FormattedMessage id="task_list.filters.late" />
            </RelativeDirectionSelect.Option>
          </RelativeDirectionSelect>
        </Line>
      )}
    </Lines>
  </Menu.Item>
);
